import { LI, UL } from "../../../../AbstractElements";

export const ProductColor = () => {
  return (
    <>
      <UL className="product-color simple-list d-flex flex-row mt-2 mb-2 mb-2">
        <LI className="bg-primary rounded-5"></LI>
        <LI className="bg-secondary"></LI>
        <LI className="bg-success"></LI>
        <LI className="bg-info"></LI>
        <LI className="bg-warning rounded-5"></LI>
      </UL>
      <hr />
    </>
  );
};
